import GameSchedule from '../components/schedule/GameSchedule'

export default function SchedulePage() {
  return <GameSchedule />
}
